import CreateCategory from "../../components/Categories/Actions/CreateCategory";

export default function CreateCategoryScreen(){
return <CreateCategory />
}